var Handlebars = require("../../../../../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label class=\"ais-facet--label1\" data-count=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"count") : depth0), depth0))
    + "\">\n    <input type=\"checkbox\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isRefined") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":27},"end":{"line":2,"column":60}}})) != null ? stack1 : "")
    + " />\n    "
    + ((stack1 = __default(require("./productRating.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"name") : depth0),0,false,{"name":"productRating","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":38}}})) != null ? stack1 : "")
    + "\n    &nbsp;and up\n    <!--<span class=\"ais-refinement-list--count\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"count") : depth0), depth0))
    + "</span>-->\n</label>\n";
},"useData":true});